import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import DataTable from '../../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { COLUMNS } from './keys';
import Loading from '../../../../../components/Loading';
import AddKeywordModal from '../addKeywordModal';
import ErrorMessage from '../../../ErrorMessage';

class BodyTable extends Component {
    constructor() {
        super();

        this.onSelect = this.onSelect.bind(this);
        this.addPromps = this.addPromps.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.onOpenAddKeywordModal = this.onOpenAddKeywordModal.bind(this);

        this.url = new URL(window.location);
        this.projectId = this.url.searchParams.get('projectId');

        this.state = {
            selectedItems: [],
            tableData: [],
            loading: false,
            didSearch: false,
            isAddKeywordModalOpen: false,
            error: '',
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.keys?.join(',')?.toLowerCase().includes(search.toLowerCase());
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({
            selectedItems: state.ids,
        });
    }

    onOpenAddKeywordModal = () => {
        this.setState({ isAddKeywordModalOpen: true });
    };

    closeAddKeywordModal = () => {
        this.setState({ isAddKeywordModalOpen: false });
    };

    addPromps() {
        this.onOpenAddKeywordModal();
    }

    render() {
        const { t } = this.props;

        const columns = COLUMNS(t, this.props.isDark, this.state.selectedItems);
        return (
            <div className="prompt-generator-google-search-body">
                {this.props.loading && <Loading padding={20} />}
                {!this.props.loading && (
                    <>
                        <DataTable
                            nodes={this.props.data}
                            sortFns={getSortKeys(columns)}
                            COLUMNS={columns}
                            hasSelect
                            onSelect={this.onSelect}
                            defaultSortKey={'impressions'}
                            customEmptyMessage={t('global.no_data')}
                            searchFunction={this.searchFunction}
                            additionalStyles={setAdditionalStyles(columns, true)}
                            notUseDefaultStyle
                        />
                        <div className="my-10 d-flex justify-content-end">
                            <div>
                                <button
                                    className="button button-primary button-filled d-flex align-items-center gap-5"
                                    onClick={this.addPromps}
                                    disabled={
                                        this.state.selectedItems.length === 0 ||
                                        this.props.available_credits === 0
                                    }
                                >
                                    {t('ai_tracking.prompt_generator.track_selected_prompts')}
                                    <div className="selected-items-count-for-track">
                                        {this.state.selectedItems.length}
                                    </div>
                                </button>
                                <div className="prompt-generation-count">
                                    {this.props.balanceLoader ? (
                                        <Loading />
                                    ) : (
                                        <>
                                            {this.props.available_credits}{' '}
                                            {t('ai_tracking.global.prompts_tracking_left')}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {!this.props.balanceLoader && this.props.available_credits === 0 && (
                            <ErrorMessage
                                message={t('ai_tracking.global.prompts_tracking_left_message')}
                            />
                        )}
                    </>
                )}
                {this.state.error && <div className="error-message">{this.state.error}</div>}
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.state.selectedItems}
                        projectId={this.projectId ? Number(this.projectId) : null}
                    />
                )}
            </div>
        );
    }
}
export default withTranslation()(BodyTable);
